<template>
  <div>
    <div class="body">
      <van-image
        class="topLogo"
        :src="require('../../../../public/image/06/1.png')"
      ></van-image>
      <div>
        <div class="bodyWarpText">
          <van-image
            class="vanImage"
            :src="require('../../../../public/image/06/6.png')"
          ></van-image>
          <div class="colorText">
            {{ gameStatus.people ? gameStatus.people : '0' }}
          </div>
          <van-image
            class="vanImage1"
            :src="require('../../../../public/image/06/5.png')"
          ></van-image>
        </div>
        <div class="bodyWarp">
          <van-image
            class="bodyWarpBanner"
            :src="require('../../../../public/image/06/3.png')"
          ></van-image>
          <div class="bodyWarpX">
            <van-image
              class="bodyWarpBanner"
              :src="require('../../../../public/image/06/4.png')"
            ></van-image>
          </div>
          <div class="listWarp">
            <div
              class="bodyWarpBanner"
              v-for="item in list"
              :key="item.bannerImage"
            >
              <div class="bodyWarpBanner1">
                <van-image
                  :src="
                    gameStatus.people >= item.number
                      ? item.bannerImage1
                      : item.bannerImage
                  "
                ></van-image>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import isMobile from '../../../../utils/isMobile.js'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['phone', 'gameStatus'])
  },
  data() {
    return {
      list: [
        {
          bannerImage: require('../../../../public/image/06/10W.png'),
          bannerImage1: require('../../../../public/image/06/10W-1.png'),
          number: 100000
        },
        {
          bannerImage: require('../../../../public/image/06/20W.png'),
          bannerImage1: require('../../../../public/image/06/20W-1.png'),
          number: 200000
        },
        {
          bannerImage: require('../../../../public/image/06/50W.png'),
          bannerImage1: require('../../../../public/image/06/50W-1.png'),
          number: 500000
        },
        {
          bannerImage: require('../../../../public/image/06/80W.png'),
          bannerImage1: require('../../../../public/image/06/80W-1.png'),
          number: 800000
        },
        {
          bannerImage: require('../../../../public/image/06/100W.png'),
          bannerImage1: require('../../../../public/image/06/100W-1.png'),
          number: 1000000
        }
      ],
      isMobile: isMobile()
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes heartbeat1 {
  0% {
    transform: translateY(0rem);
  }
  50% {
    transform: translateY(1rem);
  }
  100% {
    transform: translateY(0rem);
  }
}

.body {
  position: relative;
  width: 100%;
  height: 500px;
  background: url(../../../../public/image/10/06.jpg) no-repeat;
  background-size: 100% 100%;
  .bodyWarpText {
    // display: block;
    margin: 0 auto;
    margin-top: 0.5rem;
    display: flex;
    line-height: 24px;
    justify-content: center;
    .vanImage {
      height: 20px;
      width: 40px;
      margin: 2px 0px;
    }
    .vanImage1 {
      height: 20px;
      width: 90px;
      margin: 2px 0px;
    }
    .colorText {
      color: rgb(247, 218, 82);
      font-size: 24px;
      font-family: 'MyOTFFont', sans-serif;
      text-shadow: -1px -1px 0 rgb(117, 168, 235), 1px -1px 0 rgb(117, 168, 235),
        -1px 1px 0 rgb(117, 168, 235), 1px 1px 0 rgb(117, 168, 235); /* 上下左右四个方向的阴影，颜色为蓝色 */
      // font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
    }
  }
  .topLogo {
    display: block;
    width: 80%;
    margin: 0 auto;
    padding-top: 1rem;
  }

  .bodyWarp {
    width: 350px;
    position: relative;
    margin: 0 auto;
    margin-top: 2rem;
    .bodyWarpBanner {
      display: block;
      width: 100%;
    }
    .listWarp {
      width: 300px;
      .bodyWarpBanner {
        width: 90px;
        position: absolute;
        .bodyWarpBanner1 {
          position: relative;
        }
      }
      .bodyWarpBanner:nth-child(1) {
        top: 200px;
        left: 15px;
      }
      .bodyWarpBanner:nth-child(2) {
        top: 98px;
        left: 50%;
        transform: translateX(-50%);
      }
      .bodyWarpBanner:nth-child(3) {
        top: 170px;
        right: 25px;
      }
      .bodyWarpBanner:nth-child(4) {
        top: -25px;
        right: 25px;
      }
      .bodyWarpBanner:nth-child(5) {
        top: -20px;
        left: 15px;
      }
    }
    .bodyWarpX {
      width: 300px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/Activity06/index.vue